"use server";
import { randomBytes } from "node:crypto";
import { cookies } from "next/headers";
import { redirect } from "next/navigation";
import { db } from "@/lib/db";
import { digest, SESSION_COOKIE, verifyPassword } from "@/lib/auth";
const attempts = new Map<string, { count: number; until: number }>();
export async function login(_previous: { error: string }, data: FormData) {
 const username=String(data.get("username") ?? "").trim().slice(0,64);
 const password=String(data.get("password") ?? "");
 if (!username || !password || password.length>256) return {error:"請輸入帳號與密碼"};
 const now=Date.now(), recent=attempts.get(username);
 if (recent && recent.until>now && recent.count>=10) return {error:"嘗試次數過多，請稍後再試"};
 const attempt=recent && recent.until>now ? recent : {count:0,until:now+60_000};
 attempt.count++; attempts.set(username,attempt);
 const {rows}=await db.query("SELECT id,password_hash FROM demo_users WHERE username=$1",[username]);
 if (!rows[0] || !verifyPassword(password,rows[0].password_hash)) return {error:"帳號或密碼不正確"};
 attempts.delete(username);
 const token=randomBytes(32).toString("hex");
 await db.query("DELETE FROM demo_sessions WHERE expires_at<now()");
 await db.query("INSERT INTO demo_sessions(token_hash,user_id,expires_at) VALUES($1,$2,now()+interval '1 day')",[digest(token),rows[0].id]);
 (await cookies()).set(SESSION_COOKIE,token,{httpOnly:true,secure:true,sameSite:"lax",path:"/",maxAge:86400});
 redirect("/");
}
export async function logout() {
 const jar=await cookies(), token=jar.get(SESSION_COOKIE)?.value;
 if(token) await db.query("DELETE FROM demo_sessions WHERE token_hash=$1",[digest(token)]);
 jar.set(SESSION_COOKIE,"",{httpOnly:true,secure:true,sameSite:"lax",path:"/",maxAge:0}); redirect("/login");
}
